import { Component, OnDestroy, inject } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { centerDynamicModalConfig } from '../../shared/helpers/modal.config';
import { eModalRoles } from '../../shared/models/modals';
import { LectureGroupFormComponent } from './lecture-group-form/lecture-group-form.component';
import { canAdministerStudents } from '../../shared/helpers/osk-staff-role';

@Component({
  selector: 'app-lecture-groups',
  templateUrl: './lecture-groups.component.html',
  styleUrl: './lecture-groups.component.scss',
})
export class LectureGroupsComponent implements OnDestroy {
  private readonly primengDialogService = inject(DialogService);

  public activeIndex = 0;
  /** Groups are set up by the boss and the office; instructors and lecturers run the ones they lead. */
  public readonly canManageGroups = canAdministerStudents();
  /** Reloads the active list after a group was created. */
  public resetTable = new Subject<void>();

  private ref: DynamicDialogRef | undefined;

  ngOnDestroy(): void {
    this.ref?.close();
  }

  addNewGroup(): void {
    this.ref = this.primengDialogService.open(LectureGroupFormComponent, {
      ...centerDynamicModalConfig,
      width: '966px',
    });
    this.ref.onClose.subscribe((result) => {
      if (result === eModalRoles.SUCCESS) {
        this.activeIndex = 0;
        this.resetTable.next();
      }
    });
  }
}
